import { AuthResponse, useJWTDecode, useLocalStorage } from "@elit-hair/elit-tools";
import { ReactNode, createContext, useCallback, useContext } from "react";

import { router } from "@/components/Router";
import { AuthContext } from "@/types/providers";

const context = createContext<AuthContext>(null);

export const removeTokens = () => {
    localStorage.removeItem("auth");
    location.reload();
};

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const [auth, setAuth] = useLocalStorage<AuthResponse | null>("auth", null);

    const userData = useJWTDecode(auth?.accessToken);

    const handleLogout = useCallback(() => {
        setAuth(null);
        router.navigate("/", { replace: true });
    }, [setAuth]);

    return (
        <context.Provider
            value={{
                handleLogout,
                auth,
                setAuth,
                userData,
            }}
        >
            {children}
        </context.Provider>
    );
};

const useAuth = () => {
    const ctx = useContext(context);
    if (!ctx) {
        throw new Error("useAuth must be used within a AuthProvider");
    } else {
        return ctx;
    }
};

export default useAuth;
